<div class="separacion">
  <img src="assets/metodoTrabajo.png" alt="image" height="200" class="imagen-movil">
</div>
<div id="metodoDeTrabajo" class="card-container col-12 row full-height">
    <div class="col-12 col-lg-8 centrar">
      <p>Mi objetivo como psicóloga educativa es fomentar que todo aprendizaje sea significativo. Es muy importante que los niños y adolescentes participen y disfruten de su propio proceso de aprendizaje. En ocasiones, las diferentes formas de aprender pueden causar dificultades que afectan a su rendimiento académico.</p><br>
      <p>Dificultades en lectoescritura, déficit de atención, desmotivación, falta de organización, de hábito de estudio… todos estos problemas merecen atención. Cada niño debe sentir que es capaz de superar sus obstáculos y confiar en sí mismo.</p><br>
      <p class="naranja"><strong>[El aprendizaje es como una torre, hay que ir construyéndolo paso a paso · VYGOTSKY]</strong></p><br>
      <p>El desarrollo de la motivación hacia el aprendizaje y de la creatividad, así como la innovación educativa, son los pilares básicos de mi intervención psicoeducativa.</p><br>
      <p class="naranja"><strong>[El primer indicio claro en el desarrollo del conocimiento es la continua creatividad · PIAGET]</strong></p><br>
      <p>Trabajo partiendo de las aptitudes y actitudes de cada uno, buscando el desarrollo óptimo de su potencial y proporcionando técnicas, estrategias y métodos que fomenten ese aprendizaje significativo., Busco con ellos sus motivaciones, miedos, inseguridades… analizamos juntos sus puntos fuertes y débiles para buscar la manera en que sus dificultades no protagonicen sus aprendizajes, y confíen en sí mismos, disfruten de sus avances y busquen nuevos retos.</p><br>
      <p class="naranja"><strong>[La educación consiste en ayudar al niño a llevar a la realidad sus aptitudes · ERICH FROMM]</strong></p><br>
      <p>Los objetivos que trato de conseguir en mis sesiones son:</p><br>
      <ul>
        <li>
          <p style="margin-bottom: 0px;">Fomento de la autoestima y la autoconfianza de los alumnos en relación a su propio proceso de aprendizaje y a sus expectativas.</p>
        </li>
        <li>
          <p style="margin-bottom: 0px;">Desarrollo de la motivación hacia su aprendizaje.</p>
        </li>
        <li>
          <p style="margin-bottom: 0px;">Desarrollo de la capacidad de análisis y síntesis.</p>
        </li>
        <li>
          <p style="margin-bottom: 0px;">Desarrollo de las habilidades de lectoescritura.</p>
        </li>
        <li>
          <p style="margin-bottom: 0px;">Desarrollo de hábitos y habilidades de organización del estudio.</p>
        </li>
        <li>
          <p style="margin-bottom: 0px;">Aprendizaje de técnicas y métodos adecuados a sus necesidades.</p>
        </li>
        <li>
          <p style="margin-bottom: 0px;">Desarrollo de la creatividad.</p>
        </li>
        <li>
          <p style="margin-bottom: 0px;">Optimización del rendimiento académico.</p>
        </li>
        <li>
          <p style="margin-bottom: 0px;">Búsqueda de una actitud positiva y proactiva hacia el aprendizaje y el estudio.</p>
        </li>
      </ul><br>
      <p class="naranja"><strong>[Si un niño no puede aprender de la forma en que enseñamos, quizás deberíamos enseñar como él aprende · RITA DUNN]</strong></p>
    </div>
    <div class="col-12 col-lg-4 centrar separacion">
      <img src="assets/palomaLapiz.png" alt="image" height="400">
    </div>
</div>